import { render } from "./MatchingMediaModal.vue?vue&type=template&id=1cfcd053&scoped=true"
import script from "./MatchingMediaModal.vue?vue&type=script&lang=js"
export * from "./MatchingMediaModal.vue?vue&type=script&lang=js"

import "./MatchingMediaModal.vue?vue&type=style&index=0&id=1cfcd053&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfcd053"]])

export default __exports__